import config from "appConfig";
import { Slide } from "@jelly/lesson";

const principle: Slide = {
  titleHtml: `<div style="text-align:center">Vehicle Sound Simulation</div>`,
  title: "Added Mass",
  layout: {
    type: "customCase040202",
    options: {
      iframeSrc: `${config.IFRAMES_REACT_URL}/case-0402-01/`,
    },
  },
};

export default principle;
